import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ConfiguratorSaveQueryService, FieldTableDto, ObjectQueryFilter, SaveQuery} from '@tj/tj-dmp-lib-api';
import {AbstractFilterComponent} from '../../table/filters/abstract-filter.component';
import {SortComponent} from '../../table/filters/sort/sort.component';
import {UtilsService} from '../../../admin/services/utils.service';
import {ConfirmationService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'save-query',
    templateUrl: './save-query.component.html',
    styleUrls: ['./save-query.component.scss'],
    standalone: false
})
export class SaveQueryComponent implements OnChanges {
    @Input() readOnly = false;
    @Input() codeDataView: string = null;
    @Input() datastore: string;
    @Input() partner: string;
    /** requête complète */
    @Input() query: ObjectQueryFilter;
    /** Filtre de recherche */
    @Input() filters: AbstractFilterComponent[];
    /** critère de Trie de la recherche */
    @Input() orderings: SortComponent[];
    /** Liste des colonnes affichés  */
    @Input() displayables: string[];
    /** Liste des champs à afficher pour l'affichage de la zone d'expand */
    @Input() expandSortField: string[] = [];
    /** Liste des champs de critère de recherche suplémentaire */
    @Input() searchableExpand: string[];
    /** Liste des champs de critère de tri */
    @Input() sortField: string[];
    /** Liste des fields */
    @Input() fields: FieldTableDto[];

    @Output() onChange = new EventEmitter<SaveQuery>();

    display = false;
    radioSelect = 'new';
    currentQuery: SaveQuery;
    queryset: SaveQuery[] = [];
    name: string;

    constructor(
        private utilsService: UtilsService,
        private configuratorSaveQueryService: ConfiguratorSaveQueryService,
        private confirmationService: ConfirmationService,
        private translate: TranslateService
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.update();
    }

    clear() {
        this.currentQuery = null;
    }

    open() {
        this.display = true;
    }

    close() {
        this.display = false;
        this.name = null;
    }

    save() {
        const saveQuery: SaveQuery = {
            datastore: this.datastore,
            partner: this.partner,
            view: this.codeDataView,
            name: this.name,
            query: this.query,
            filters: this.filters
                .map((f) => {
                    return f.getSaveContraint();
                })
                .filter((f) => f.constraint != null),
            displayables: this.displayables,
            expandSortField: this.expandSortField,
            orderings: this.orderings.map((o) => {
                return {
                    asc: o.order !== 'DESC',
                    code: o.field.code,
                };
            }),
            searchableExpand: this.searchableExpand,
            sortField: this.sortField,
        };
        // nouveau
        if (this.radioSelect === 'new') {
            this.radioSelect = 'modif';
            this.configuratorSaveQueryService
                .createSaveQueryUsingPOST(this.datastore, saveQuery)
                .subscribe((res) => {
                    this.update();
                    this.currentQuery = res;
                });
        } else {
            if (this.currentQuery == null) {
                this.currentQuery = this.queryset[0];
            }
            saveQuery.id = this.currentQuery.id;
            saveQuery.name = this.currentQuery.name;
            saveQuery.description = this.currentQuery.description;
            this.configuratorSaveQueryService
                .updateSaveQueryUsingPUT(this.datastore, saveQuery)
                .subscribe((res) => {
                    this.update();
                    this.currentQuery = res;
                });
        }
        this.close();
    }

    delete(event: Event) {
        if (this.currentQuery) {
            this.confirmationService.confirm({
                target: event.target,
                message: this.translate.instant('common.confirm'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.translate.instant('common.True'),
                rejectLabel: this.translate.instant('common.False'),
                accept: () => {
                    this.configuratorSaveQueryService
                        .deleteSaveQueryUsingDELETE(this.datastore, this.currentQuery.id)
                        .subscribe(() => {
                            this.update();
                        });
                },
                reject: () => {
                    // reject action
                }
            });
        }
    }

    change(event: any): void {
        console.log(event);
        if (this.currentQuery) {
            this.onChange.emit(this.currentQuery);
        }
    }

    private update() {
        if (this.codeDataView != null && this.datastore != null) {
            this.queryset = [];
            this.configuratorSaveQueryService
                .getAllSaveQuerysByDatastoreUsingGET(this.datastore, this.partner, this.codeDataView)
                .subscribe((res) => {
                    if (res) {
                        this.queryset = res;
                    }
                });
        }
    }

    private getField(code: any): FieldTableDto {
        return this.fields.find((f) => f.code === code);
    }
}
